// Compares what the browser asked for in Accept-Language against what navigator.language reports,
// so the two signals can be checked against each other before either is routed on.
export function getLanguageAnalyticsProperties(
  headerLanguage: string | null | undefined
) {
  const navigatorLanguage = globalThis.navigator?.language
    ?.split('-')[0]
    .toLowerCase()

  return {
    'Header Language': headerLanguage,
    'Navigator Language': navigatorLanguage,
    // Only meaningful when both sides exist, so an absent header is not counted as a mismatch.
    ...(headerLanguage &&
      navigatorLanguage && {
        'Is Same Language': headerLanguage === navigatorLanguage,
      }),
  }
}
